import { Box } from "@mui/material";
import {
  TOP_NAV_HEIGHT_DESKTOP,
  TOP_NAV_HEIGHT_DESKTOP_NUMBER,
  TOP_NAV_HEIGHT_MOBILE,
  TOP_NAV_WIDTH_MOBILE_MAX,
  TOP_NAV_Z_INDEX,
} from "@/app/layout/GlobalNav";
import { BOX_SHADOW_SIZE_MEDIUM } from "./LayoutConstants";
import { useTopNavHeadroom } from "./useTopNavHeadroom";

export default function SubNav({
  collapseOnScroll,
  children,
}: {
  collapseOnScroll?: boolean;
  children: React.ReactNode;
}) {
  const { isCollapsed } = useTopNavHeadroom();

  return (
    <Box
      sx={(theme) => ({
        position: "sticky",
        width: "100%",
        top: TOP_NAV_HEIGHT_DESKTOP,
        transition: theme.transitions.create("top", {
          duration: theme.transitions.duration.standard * 2,
          easing: theme.transitions.easing.easeInOut,
        }),
        zIndex: TOP_NAV_Z_INDEX - 10,
        [theme.breakpoints.down(TOP_NAV_WIDTH_MOBILE_MAX)]: {
          top: TOP_NAV_HEIGHT_MOBILE,
          position: "fixed",
        },
        boxShadow: BOX_SHADOW_SIZE_MEDIUM,
        "&.is-collapsed": {
          top: "-" + TOP_NAV_HEIGHT_DESKTOP_NUMBER * 2 + "px",
        },
      })}
      className={isCollapsed && collapseOnScroll ? "is-collapsed" : ""}
    >
      {children}
    </Box>
  );
}
